import clsx from "clsx"
import classes from "./InputTopWithButtons.module.scss"
import { useRef } from "react"
import { useEffect } from "react"
import { useState } from "react"
import ButtonSend from "../ButtonSend"

const InputTopWithButtons = function InputWithButtons(props) {
    const { type = "text", className, onSubmit, onClose, ...inputProps } = props

    const inputRef = useRef();
    const [inputValue, setInputValue] = useState('');
    const isInputEmpty = inputValue === '';

    const onChangeHandler = (e) => {
        setInputValue(e.target.value.trim());
    }

    useEffect(() => {
        const closeInput = () => {
            onClose()
        }
        window.addEventListener("map-click", closeInput);
        return () => {
            window.removeEventListener("map-click", closeInput);
        }
    }, [onClose])

    const onSubmitHandler = (e) => {
        e.preventDefault();
        if (!inputValue) return;
        onSubmit(inputValue);
    }

    useEffect(() => {
        inputRef.current.focus();
    }, [])

    return (
        <div className={clsx(classes.fullwidth, className)}>
            <div className={clsx(classes.inputWrapper)}>
                <form onSubmit={onSubmitHandler} style={{ display: "contents" }} >
                    <input className={classes.input} type={type} ref={inputRef} {...inputProps} onChange={onChangeHandler} />
                    <div className={classes.actions}>

                        <ButtonSend
                            onClick={onSubmitHandler}
                            disabled={isInputEmpty}
                        />
                    </div>
                </form>
            </div>
        </div>
    )
}

export default InputTopWithButtons